function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @copyright Copyright (c) 2020 Florian Steffens <flost-dev@mailbox.org>
 *
 * @author Florian Steffens <flost-dev@mailbox.org>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import axios from '@nextcloud/axios';
import { generateUrl } from '@nextcloud/router';
export var ActivitiesApi = /*#__PURE__*/function () {
  function ActivitiesApi() {
    _classCallCheck(this, ActivitiesApi);
  }

  _createClass(ActivitiesApi, [{
    key: "url",
    value: function url(_url) {
      _url = "/apps/health/activities".concat(_url);
      return generateUrl(_url);
    }
  }, {
    key: "findDatasetsByPerson",
    value: function findDatasetsByPerson(personId) {
      return axios.get(this.url("/dataset/person/".concat(personId))).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "addSet",
    value: function addSet(personId, set) {
      // console.debug('try to send new dataset to BE')
      return axios.post(this.url("/dataset/person/".concat(personId)), set).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "deleteSet",
    value: function deleteSet(set) {
      // console.debug('try to remove from BE', { set: set, url: this.url(`/dataset/${set.id}`) })
      return axios.delete(this.url("/dataset/".concat(set.id))).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "updateSet",
    value: function updateSet(set) {
      return axios.put(this.url("/dataset/".concat(set.id)), set).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }]);

  return ActivitiesApi;
}();